import React from "react";
import ReactDatePicker from "react-datepicker";
import styled from "styled-components";
import { colorAttentionBlue10, colorFunctionalGray50, colorFunctionalWhite, colorLayoutBorder, colorMiscBlue70, IconCalendarWeek, } from "@rhumbix/rmbx_design_system_design_tokens";
import "react-datepicker/dist/react-datepicker.css";
/* Custom Input for the start date picker, shows the calendar icon if the DatePicker is active */
const CustomInput = React.forwardRef((props, ref) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { ref: ref, ...props }),
        React.createElement(DateInputIcon, { hidden: props.disabled, onClick: props.onClick },
            React.createElement(IconCalendarWeek, { color: colorMiscBlue70, width: 20, height: 20 }))));
});
const DatePicker = props => (React.createElement(StyledDatePicker, { ...props, customInput: React.createElement(CustomInput, { disabled: props.disabled }) }));
const StyledDatePicker = styled(ReactDatePicker) `
    color: ${colorMiscBlue70};
    background-color: ${colorAttentionBlue10};
    border: 0;
    border-radius: 5px;
    display: inline-block;
    font-size: 14px;
    height: 38px;
    min-width: 0;
    padding: 0px 8px;
    width: 100%;
    &[disabled] {
        background-color: ${colorFunctionalWhite};
        color: ${colorFunctionalGray50};
        border: 1px solid ${colorLayoutBorder};
    }
`;
const DateInputIcon = styled.i `
    position: absolute;
    right: 8px;
    top: 8px;
`;
export default DatePicker;
